import {createAction} from '@reduxjs/toolkit'

/**
 * state 기준으로 업데이트 해야하는 payload
 * - 임시 action 쿠폰 적용 및 api 반영 시점으로 이동 필요
 **/
export type RecalculatePayloadType = {
    /** 최종 할인 값 */
    totalDiscountAmount: number
    /** 상품 할인 금액 */
    productDiscountAmount: number
    /** 배송비 할인 금액 */
    deliveryDiscountAmount: number
}

export const recalculateAction = createAction<RecalculatePayloadType>('orderTotal/recalculateAction')
